const MAP = {
  severe: { bg: "bg-red-50", border: "border-red-300", text: "text-red-800", dot: "bg-red-600", label: "Severe" },
  warning: { bg: "bg-amber-50", border: "border-amber-300", text: "text-amber-800", dot: "bg-amber-600", label: "Warning" },
  advisory: { bg: "bg-yellow-50", border: "border-yellow-300", text: "text-yellow-800", dot: "bg-yellow-500", label: "Advisory" },
  normal: { bg: "bg-green-50", border: "border-green-300", text: "text-green-800", dot: "bg-green-600", label: "Normal" },
};

export function SeverityChip({ level, className = "" }) {
  const s = MAP[level] || MAP.normal;
  return (
    <span data-testid={`severity-${level}`} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-mono font-semibold uppercase tracking-wide ${s.bg} ${s.border} ${s.text} ${className}`}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} aria-hidden />
      {s.label}
    </span>
  );
}

export function ProvenanceBadge({ provenance, isDemo }) {
  const labels = {
    official: { t: "VERIFIED OFFICIAL SOURCE", c: "bg-navy text-white" },
    automated: { t: "AUTOMATED FEED DATA", c: "bg-slate-200 text-navy" },
    editorial: { t: "EDITORIAL SUMMARY", c: "bg-blue-100 text-royal" },
  };
  const l = labels[provenance] || labels.automated;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <span className={`label-caps rounded px-1.5 py-0.5 ${l.c}`}>{l.t}</span>
      {isDemo && <span className="label-caps rounded bg-orange-100 px-1.5 py-0.5 text-orange-800 border border-orange-300">DEMO DATA</span>}
    </span>
  );
}

export const SEV_BORDER = {
  severe: "border-l-red-600", warning: "border-l-amber-600",
  advisory: "border-l-yellow-500", normal: "border-l-green-600",
};
